import Messages from './messages.js'

export default class NetworkClient {

  constructor(socket) {
    this.socket = socket
  }

  /**
   * Reflect network status on LED
   * 
   * @param {("NO_CONNECTION"|"NO_INTERNET"|"CONNECTED")} status - Status of network
   * @param {boolean} blink - Whether to blink LED or not
   * @returns {Promise<void>} 
   * @throws {Error}
   */
  async setStatus(status, blink) {
    let response;
    try {
      response = await this.socket.emitWithAck(Messages.Network_SetStatus, status, blink);
    } catch (error) {
      console.error(`NetworkClient : ${error}`)
      throw new Error('Socket Error')
    }
    if (!response.success) {
      const error = `${response.error.code}:${response.error.message}`
      throw new Error(error)
    }
    return
  }
}